var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "empty-records" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "col-xs-12" },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._t("default", function() {
              return [
                _vm._v("\n      " + _vm._s(_vm.$t("LOADING_TEXT")) + "\n    ")
              ]
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loader-container" }, [
      _c("div", { staticClass: "loader" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }